import { utilities } from 'core';
import parseUrl from 'url-parse';

import { removeAppDomainFromPath } from './remove-app-domain-from-path';

import type { LinkProps, LocationDescriptor } from '../@types';

/**
 * Parse string location into object location descriptor removing app domain from pathname.
 *
 */
export function parseTargetLocation(to: LinkProps['to']) {
  const {
    hash = '',
    pathname = '',
    query: search = '',
  } = typeof to === 'string' ? parseUrl(to) : parseUrl(to?.pathname || '');

  return {
    ...(typeof to === 'object' ? { ...to } : {}),
    pathname: removeAppDomainFromPath(utilities.getBasePathname(pathname))!,
    search,
    hash,
  } as LocationDescriptor;
}
